import { render, staticRenderFns } from "./SoftwareAvisos.vue?vue&type=template&id=0cd68170"
import script from "./SoftwareAvisos.vue?vue&type=script&lang=js"
export * from "./SoftwareAvisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports